import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import AuthPage from "@/pages/AuthPage";
import RequestAccess from "@/pages/RequestAccess";
import AcceptInvite from "@/pages/AcceptInvite";
import SearchPage from "@/pages/SearchPage";
import PlayerProfile from "@/pages/PlayerProfile";
import AdminPage from "@/pages/admin/AdminPage";
import LeadersPage from "@/pages/LeadersPage";
import FinderPage from "@/pages/FinderPage";
import SavedSearchesPage from "@/pages/SavedSearchesPage";

const Home = () => {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen bg-[#0B0F19]" />;
  return user ? <Navigate to="/players" replace /> : <Landing />;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<AuthPage mode="login" />} />
            <Route path="/register" element={<Navigate to="/request-access" replace />} />
            <Route path="/request-access" element={<RequestAccess />} />
            <Route path="/accept-invite" element={<AcceptInvite />} />
            <Route path="/players" element={<ProtectedRoute><SearchPage /></ProtectedRoute>} />
            <Route path="/players/:id" element={<ProtectedRoute><PlayerProfile /></ProtectedRoute>} />
            <Route path="/saved" element={<ProtectedRoute><SavedSearchesPage /></ProtectedRoute>} />
            <Route path="/prototypes" element={<ProtectedRoute><FinderPage /></ProtectedRoute>} />
            <Route path="/leaders" element={<ProtectedRoute><LeadersPage /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute admin><AdminPage /></ProtectedRoute>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="top-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
